import { Editor } from '@tiptap/core';
import { BubbleMenu } from '@tiptap/react';
import { Toolbar } from 'copilot-design-system';

import { EditorMenu } from 'src/components/tiptap/editor-menu/EditorMenu';

/**
 * This component is used to render the editor toobar when
 * the editor content is highlighted.
 * TODO: reuse this component in other places like NoteModal.tsx
 * @param tiptapEditor - The tiptap editor instance
 * @param enableNewEditorFormatter - Whether the new editor formatter is enabled
 * @returns The highlight toolbar component
 */
export const HighlightToolbar = ({
  tiptapEditor,
  enableNewEditorFormatter,
}: {
  tiptapEditor: Editor | null;
  enableNewEditorFormatter: boolean | undefined;
}) => {
  if (!tiptapEditor) return null;
  return (
    <BubbleMenu
      editor={tiptapEditor}
      tippyOptions={{ duration: 100, maxWidth: 'none' }}
    >
      {enableNewEditorFormatter ? (
        <Toolbar variant="highlight" />
      ) : (
        <EditorMenu
          editor={tiptapEditor}
          textMenuActions={['heading2', 'heading3', 'text']}
        />
      )}
    </BubbleMenu>
  );
};
